import { useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="header_sec">
      <Navbar
        expand="lg"
        className="header_nav"
        collapseOnSelect
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <div className="container-md">
          <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
            <img
              className="logoimg"
              src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
              alt="logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          />

          <Navbar.Collapse id="basic-navbar-nav" className="mobile_collapse">
            <Nav className="mx-auto">
              <Nav.Link
                as={Link}
                to="/"
                onClick={() => setExpanded(false)}
                className={location.pathname === "/" ? "active" : ""}
              >
                Home
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/about-us"
                onClick={() => setExpanded(false)}
                className={location.pathname === "/about-us" ? "active" : ""}
              >
                About Us
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/services"
                onClick={() => setExpanded(false)}
                className={
                  location.pathname.startsWith("/services") ? "active" : ""
                }
              >
                Services
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/facilities"
                onClick={() => setExpanded(false)}
                className={
                  location.pathname.startsWith("/facilities") ? "active" : ""
                }
              >
                Facilities
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/our-clients"
                onClick={() => setExpanded(false)}
                className={location.pathname === "/our-clients" ? "active" : ""}
              >
                Our Clients
              </Nav.Link>

              {/* <Nav.Link
                as={Link}
                to="/blogs"
                onClick={() => setExpanded(false)}
                className={
                  location.pathname.startsWith("/blogs") ? "active" : ""
                }
              >
                Blogs
              </Nav.Link> */}

              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => setExpanded(false)}
                className={location.pathname === "/contact" ? "active" : ""}
              >
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </section>
  );
}

export default Header;
